import Immutable from "seamless-immutable";
import { APP_ERROR } from "../types/App";

// Create initial Redux State for "user"
const INITIAL_STATE = Immutable({
  data: null,
});

const TrackingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case APP_ERROR:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default TrackingReducer;
